import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { registerSupplierStripeUserAsync } from "../supplierPaymentSlice"
import { RootState } from "typesafe-actions"
import { browserHistory } from "../../store/store"
import { Typography } from "@material-ui/core"
import QmoLoader from "../../Common/QmoLoader"

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

export default function RegisterSupplierInPaymentService() {
    const dispatch = useDispatch()
    const query = useQuery()
    const _supplierPayment = useSelector((state: RootState) => state.supplierPaymentRdc)

    useEffect(() => {
        if(query.get("state") !== undefined && query.get("code")!== undefined)
            dispatch(registerSupplierStripeUserAsync(query.get("state")!, query.get("code")!))
    }, [])

    useEffect(() => {
        if (_supplierPayment.registerStripeUserSuccess === true)
            browserHistory.push("/")
    }, [_supplierPayment.registerStripeUserSuccess])

    return (
        <div>
            <Typography variant="h2">Connecting your payment account...</Typography>
            {_supplierPayment.registerStripeUserBusy &&
                <QmoLoader qmoAnimation={true} />

            }

            {_supplierPayment.registerStripeUserSuccess === false &&
                <Typography color="error">There was problem while registering your account, please try again.</Typography>
            }
        </div>
    )
}